/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectImportPreviewsControllerCreateMutationResponse, ProjectImportPreviewsControllerCreate400, ProjectImportPreviewsControllerCreate401, ProjectImportPreviewsControllerCreate403, ProjectImportPreviewsControllerCreate404 } from "../../models/projectsController/ProjectImportPreviewsControllerCreate";

function getProjectImportPreviewsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/project-import-previews` as const }  
  return res
}

/**
 * @description Parses and validates an XLSX project import entirely in memory without persisting the file or preview.
 * @summary Preview a project spreadsheet import
 * {@link /api/v1/project-import-previews}
 */
export async function projectImportPreviewsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectImportPreviewsControllerCreateMutationResponse, ResponseErrorConfig<ProjectImportPreviewsControllerCreate400 | ProjectImportPreviewsControllerCreate401 | ProjectImportPreviewsControllerCreate403 | ProjectImportPreviewsControllerCreate404>, unknown>({ method : "POST", url : getProjectImportPreviewsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}